import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AuthProvider from './components/AuthProvider/AuthProvider';
import RequireAuth from './components/RequireAuth/RequireAuth';
const EditTicketPage = lazy(() =>
  import('./pages/EditTicketPage/EditTicketPage')
);
const SignInPage = lazy(() => import('./pages/SignInPage/SignInPage'));
const TicketsPage = lazy(() => import('./pages/TicketsPage/TicketsPage'));
const ScheduledTicketsPage = lazy(() =>
  import('./pages/ScheduledTicketsPage/ScheduledTicketsPage')
);
const UnscheduledTicketsPage = lazy(() =>
  import('./pages/UnscheduledTicketsPage/UnscheduledTicketsPage')
);
const ResolvedTicketsPage = lazy(() =>
  import('./pages/ResolvedTicketsPage/ResolvedTicketsPage')
);
const AddTicketPage = lazy(() => import('./pages/AddTicketPage/AddTicketPage'));

const App = () => (
  <AuthProvider>
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <RequireAuth>
              <Suspense fallback={<></>}>
                <TicketsPage />
              </Suspense>
            </RequireAuth>
          }
        />
        <Route
          path="/scheduled"
          element={
            <RequireAuth>
              <Suspense fallback={<></>}>
                <ScheduledTicketsPage />
              </Suspense>
            </RequireAuth>
          }
        />
        <Route
          path="/unscheduled"
          element={
            <RequireAuth>
              <Suspense fallback={<></>}>
                <UnscheduledTicketsPage />
              </Suspense>
            </RequireAuth>
          }
        />
        <Route
          path="/resolved"
          element={
            <RequireAuth>
              <Suspense fallback={<></>}>
                <ResolvedTicketsPage />
              </Suspense>
            </RequireAuth>
          }
        />
        <Route
          path="/new"
          element={
            <RequireAuth>
              <Suspense fallback={<></>}>
                <AddTicketPage />
              </Suspense>
            </RequireAuth>
          }
        />
        <Route
          path="/edit/:id"
          element={
            <RequireAuth>
              <Suspense fallback={<></>}>
                <EditTicketPage />
              </Suspense>
            </RequireAuth>
          }
        />
        <Route
          path="/sign-in"
          element={
            <Suspense fallback={<></>}>
              <SignInPage />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);

export default App;
